import { Info, Pencil, X } from "lucide-react";
import { DIAGNOSTIC } from "@/constants/testIds";
import { labelForNeed } from "@/features/diagnostic/config";
import { Container } from "@/components/site/Primitives";
import { Wordmark } from "@/components/site/Nav";

export const DiagnosticHeader = ({ onExit }) => (
  <header className="relative border-b border-fg/[0.06]">
    <Container className="flex h-16 items-center justify-between gap-4">
      <nav aria-label="Breadcrumb" className="min-w-0">
        <ol className="flex items-center gap-2 text-[13px] text-subtle">
          <li className="flex shrink-0 items-center gap-2"><Wordmark className="w-[112px] sm:w-[132px]" /> <span className="text-fg">Intelligence</span></li>
          <li aria-hidden className="text-fg/20">/</li>
          <li className="hidden truncate sm:block">Business Diagnostic</li>
          <li aria-hidden className="hidden text-fg/20 sm:block">/</li>
          <li className="shrink-0 rounded-full border border-tone/50 px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-[0.18em] text-tone">Preview</li>
        </ol>
      </nav>
      <button type="button" onClick={onExit} data-testid={DIAGNOSTIC.exit}
        aria-label="Exit preview" className="fa-link shrink-0 rounded-sm text-[13px] text-subtle hover:text-fg"><span className="hidden sm:inline">Exit preview</span><X size={18} className="sm:hidden" aria-hidden /></button>
    </Container>
  </header>
);

export const PreviewNotice = () => (
  <div data-testid={DIAGNOSTIC.previewNotice} role="note"
    className="flex items-start gap-3 rounded-xl border border-tone/30 bg-tone/[0.07] px-5 py-4 text-[14px] text-fg">
    <Info size={16} className="mt-0.5 shrink-0 text-tone" aria-hidden />
    <p>No AI analysis is running. Your contact details, business need and the answers you send here are stored for review by our team.</p>
  </div>
);

export const SubmittedContext = ({ submitted, onEdit }) => (
  <aside data-testid={DIAGNOSTIC.context} aria-label="Your submitted context" className="min-w-0 lg:sticky lg:top-8 lg:self-start">
    <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-subtle">Your submitted context</p>
    {submitted.needs.length > 0 && (
      <ul className="mt-5 flex flex-wrap gap-2">
        {submitted.needs.map((id) => (
          <li key={id} className="rounded-full border border-fg/12 bg-fg/[0.04] px-3 py-1 text-[13px] text-fg">{labelForNeed(id)}</li>
        ))}
      </ul>
    )}
    {submitted.details && (
      <blockquote className="mt-5 whitespace-pre-wrap break-words border-l border-tone/60 pl-4 text-[14px] leading-relaxed text-subtle">
        {submitted.details}
      </blockquote>
    )}
    <button type="button" onClick={onEdit} data-testid={DIAGNOSTIC.editNeed}
      className="fa-link mt-6 inline-flex items-center gap-2 rounded-sm text-[13px] text-fg hover:text-tone">
      <Pencil size={13} aria-hidden /> Edit business need
    </button>
  </aside>
);
